(function () {
  'use strict';

  var HDR_DRAWER_OPEN = 'data-hdr-drawer-open';
  var scrollY = 0;
  var _closeAll = function () {};
  var _closeDrawer = function () {};
  var _hdrWrapper = null;

  // Global listeners registered once — delegates to current init() closures via module vars
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    _closeDrawer();
    _closeAll();
  });

  // Fired by header-quick-add.js so the cart drawer isn't hidden behind the mega menu
  document.addEventListener('hdr:close-menus', function () {
    _closeAll();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) {
      _closeDrawer();
      _closeAll();
    }
  });

  // ── Scroll-aware mobile header ──────────────────────────────
  (function () {
    var lastY = 0;
    var ticking = false;
    var THRESHOLD = 80;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (_hdrWrapper) {
          if (y < THRESHOLD) {
            _hdrWrapper.classList.remove('hdr--scrolled-down');
          } else if (y > lastY) {
            _hdrWrapper.classList.add('hdr--scrolled-down');
          } else {
            _hdrWrapper.classList.remove('hdr--scrolled-down');
          }
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }());

  function init(root) {
    root = root || document;
    _closeAll = function () {};
    _closeDrawer = function () {};

    var wrapper = root.querySelector('[data-hdr]');
    if (!wrapper) return;
    _hdrWrapper = wrapper;

    // ── Announcement dismiss ──────────────────────────────────
    var ann = wrapper.querySelector('.hdr-ann');
    if (ann) {
      try {
        var until = parseInt(localStorage.getItem('hdr_ann_dismissed_until'), 10);
        if (until && Date.now() < until) ann.hidden = true;
      } catch (e) {}

      var dismissBtn = ann.querySelector('.hdr-ann__dismiss');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', function () {
          ann.hidden = true;
          try { localStorage.setItem('hdr_ann_dismissed_until', Date.now() + 86400000); } catch (e) {}
        });
      }
    }

    // ── Desktop dropdowns ─────────────────────────────────────
    var navItems = wrapper.querySelectorAll('.hdr-nav-item');
    var scrim = wrapper.querySelector('[data-hdr-scrim]');

    function closeAll() {
      navItems.forEach(function (btn) {
        btn.setAttribute('data-open', 'false');
        btn.setAttribute('aria-expanded', 'false');
      });
      wrapper.querySelectorAll('.hdr-dd').forEach(function (p) { p.hidden = true; });
      if (scrim) scrim.hidden = true;
    }

    _closeAll = closeAll;

    function openPanel(key) {
      navItems.forEach(function (btn) {
        var isThis = btn.getAttribute('data-hdr-key') === key;
        btn.setAttribute('data-open', isThis ? 'true' : 'false');
        btn.setAttribute('aria-expanded', isThis ? 'true' : 'false');
      });
      wrapper.querySelectorAll('.hdr-dd').forEach(function (p) {
        p.hidden = p.getAttribute('data-hdr-panel') !== key;
      });
      if (scrim) scrim.hidden = false;
    }

    navItems.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        openPanel(btn.getAttribute('data-hdr-key'));
      });
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-hdr-key');
        if (btn.getAttribute('data-open') === 'true') {
          closeAll();
        } else {
          openPanel(key);
        }
      });
    });

    var bar = wrapper.querySelector('[data-hdr-bar]');
    if (bar) {
      bar.addEventListener('mouseleave', function (e) {
        // only close if we left the header bar (not moving into a dd panel)
        var to = e.relatedTarget;
        if (!wrapper.contains(to)) closeAll();
      });
    }

    // also close when leaving dropdown panels back outside
    wrapper.querySelectorAll('.hdr-dd').forEach(function (panel) {
      panel.addEventListener('mouseleave', function (e) {
        var to = e.relatedTarget;
        if (!wrapper.contains(to)) closeAll();
      });
    });

    // The scrim is a full-viewport overlay that sits inside the wrapper, so
    // leaving the bar/panel lands the cursor on it and the mouseleave guards
    // above (wrapper.contains) treat it as "still inside". Closing on the
    // scrim is what makes the menu collapse as soon as the cursor moves off
    // the mega menu. The panel is flush under the bar, so moving bar↔panel
    // never crosses the scrim.
    if (scrim) {
      scrim.addEventListener('mouseenter', closeAll);
      scrim.addEventListener('click', closeAll);
    }

    // ── Search modal trigger ──────────────────────────────────
    wrapper.querySelectorAll('[data-hdr-search-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var searchModal = document.querySelector('#search-modal');
        if (searchModal && typeof searchModal.showDialog === 'function') {
          e.preventDefault();
          searchModal.showDialog();
        }
        // fallback: href navigates to search page
      });
    });

    // ── Cart drawer trigger ───────────────────────────────────
    wrapper.querySelectorAll('[data-hdr-cart-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          e.preventDefault();
          cartDrawer.open();
        }
        // no cart-drawer-component → fallback href navigates to cart page
      });
    });

    // ── Mobile drawer ─────────────────────────────────────────
    var drawer = wrapper.querySelector('[data-hdr-drawer]');
    if (!drawer) return;

    var openBtn = wrapper.querySelector('[data-hdr-open-drawer]');
    var closeBtn = drawer.querySelector('[data-hdr-close-drawer]');
    var drawerScrim = drawer.querySelector('.hdr-drawer__scrim');

    function openDrawer() {
      scrollY = window.scrollY;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.setAttribute(HDR_DRAWER_OPEN, 'true');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.removeAttribute(HDR_DRAWER_OPEN);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.focus();
      }
      var sr = drawer.querySelector('[data-hdr-search-results]');
      if (sr) { sr.hidden = true; sr.innerHTML = ''; }
      var si = drawer.querySelector('[data-hdr-search-input]');
      if (si) si.value = '';
      drawer.querySelectorAll('[data-hdr-acc-toggle]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('[data-hdr-acc-panel]').forEach(function (p) {
        p.hidden = true;
      });
    }

    _closeDrawer = closeDrawer;

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawerScrim) drawerScrim.addEventListener('click', closeDrawer);

    // close on any nav link tap inside the sheet
    var sheet = drawer.querySelector('.hdr-drawer__sheet');
    if (sheet) {
      sheet.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeDrawer);
      });
    }

    // ── Mobile pill switcher ──────────────────────────────────
    var pills = drawer.querySelectorAll('.hdr-feat__pill');
    var cards = drawer.querySelectorAll('.hdr-feat__card');

    function activatePill(rodId) {
      pills.forEach(function (p) {
        p.setAttribute('data-active', p.getAttribute('data-rod-id') === rodId ? 'true' : 'false');
        p.setAttribute('aria-selected', p.getAttribute('data-rod-id') === rodId ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        var isActive = c.getAttribute('data-rod-id') === rodId;
        c.hidden = !isActive;
        c.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        activatePill(pill.getAttribute('data-rod-id'));
      });
      pill.addEventListener('keydown', function (e) {
        var idx = Array.from(pills).indexOf(pill);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          pills[(idx + 1) % pills.length].focus();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          pills[(idx - 1 + pills.length) % pills.length].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activatePill(pill.getAttribute('data-rod-id'));
        }
      });
    });

    // ── Mobile accessories accordion ─────────────────────────
    drawer.querySelectorAll('[data-hdr-acc-toggle]').forEach(function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? drawer.querySelector('#' + panelId) : null;
      if (!panel) {
        var wrap = toggle.closest('[data-hdr-acc]');
        panel = wrap && wrap.querySelector('[data-hdr-acc-panel]');
      }
      if (!panel) return;
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });

    // ── Predictive search ────────────────────────────────────
    var searchWrap = drawer.querySelector('[data-hdr-search-wrap]');
    if (searchWrap) {
      var searchInput = searchWrap.querySelector('[data-hdr-search-input]');
      var searchResults = searchWrap.querySelector('[data-hdr-search-results]');
      var searchUrl = searchWrap.getAttribute('data-search-url') || '/search/suggest.json';
      var searchTimer = null;

      function clearSearch() {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
      }

      function renderResults(products) {
        if (!products.length) { clearSearch(); return; }
        searchResults.innerHTML = products.map(function (p) {
          var img = p.featured_image
            ? '<img src="' + p.featured_image.url + '" alt="' + (p.featured_image.alt || '') + '" loading="lazy">'
            : '';
          return '<a href="' + p.url + '" class="hdr-sr">' +
            '<div class="hdr-sr__img">' + img + '</div>' +
            '<div class="hdr-sr__info">' +
              '<div class="hdr-sr__title">' + p.title + '</div>' +
              (p.price ? '<div class="hdr-sr__price">' + p.price + '</div>' : '') +
            '</div>' +
            '</a>';
        }).join('');
        searchResults.hidden = false;
      }

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          clearTimeout(searchTimer);
          var q = searchInput.value.trim();
          if (q.length < 2) { clearSearch(); return; }
          searchTimer = setTimeout(function () {
            fetch(searchUrl + '?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=5' +
              '&resources[options][unavailable_products]=last')
              .then(function (r) { return r.json(); })
              .then(function (data) {
                var products = data.resources && data.resources.results && data.resources.results.products || [];
                renderResults(products);
              })
              .catch(function () { clearSearch(); });
          }, 250);
        });

        document.addEventListener('click', function (e) {
          if (!searchWrap.contains(e.target)) clearSearch();
        });
      }
    }

    // ── Focus trap in drawer ──────────────────────────────────
    if (sheet) {
      sheet.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = Array.from(sheet.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) { return !el.closest('[hidden]'); });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }
  }

  // init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // re-init when theme editor reloads the section
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    document.body.removeAttribute(HDR_DRAWER_OPEN);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  });
})();
